import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { microsoftSignInPage } from './SignIn';

const dashboardPage = PageBlueprint.make({
  name: 'dashboard',
  params: {
    path: '/',
    title: 'Home',
    noHeader: true,
    loader: () => import('../home/Dashboard').then(m => <m.Dashboard />),
  },
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, microsoftSignInPage, dashboardPage],
});
